var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepImg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.471 38.3408L10 57.6138V59.9998H10.838L23.056 41.1188L22.471 38.3408Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9453 41.1188L51.1633 59.9998H52.0013V57.6138L39.5303 38.3408L38.9453 41.1188Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 4H55V6H57V4Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59 6H57V8H59V6Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57 8H55V10H57V8Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55 6H53V8H55V6Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 0H15V2H17V0Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H17V4H19V2Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4H15V6H17V4Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H13V4H15V2Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H2V10H4V8Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H4V12H6V10Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H2V14H4V12Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10H0V12H2V10Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49 12H47V14H49V12Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51 14H49V16H51V14Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49 16H47V18H49V16Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47 14H45V16H47V14Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.0002H26.834L23.461 22.8432C23.087 22.6042 22.915 22.1462 23.04 21.7202C23.165 21.2932 23.556 21.0002 24 21.0002H28.323L30.071 16.6292C30.224 16.2492 30.591 16.0002 31 16.0002C31.409 16.0002 31.776 16.2492 31.929 16.6292L33.677 21.0002H38C38.444 21.0002 38.835 21.2932 38.96 21.7202C39.085 22.1462 38.913 22.6042 38.539 22.8432L35.166 25.0002H38C39.654 25.0002 41 23.6542 41 22.0002C41 17.1162 37.405 14.4672 34.189 13.0732C33.264 13.6572 32.172 14.0002 31 14.0002C29.828 14.0002 28.736 13.6572 27.811 13.0732C24.595 14.4672 21 17.1162 21 22.0002C21 23.6542 22.346 25.0002 24 25.0002Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12C33.206 12 35 10.206 35 8V6C35 3.794 33.206 2 31 2C28.794 2 27 3.794 27 6V8C27 10.206 28.794 12 31 12Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37.8981V54.0001H34.189L37.821 36.7501C37.94 36.1841 38.001 35.6031 38.001 35.0221C38.001 32.9441 37.234 30.9801 35.891 29.4661L35.965 29.7321C36.081 30.1531 35.911 30.6011 35.546 30.8381C35.378 30.9461 35.188 31.0001 35 31.0001C34.773 31.0001 34.548 30.9231 34.363 30.7711L31 27.9971L27.637 30.7711C27.299 31.0481 26.824 31.0751 26.455 30.8381C26.09 30.6011 25.92 30.1521 26.036 29.7321L26.11 29.4661C24.767 30.9801 24 32.9441 24 35.0221C24 35.6021 24.061 36.1831 24.18 36.7501L27.811 54.0001H30V37.8981C28.259 37.5721 27 36.4211 27 35.0001H29C29 35.4081 29.779 36.0001 31 36.0001C32.221 36.0001 33 35.4081 33 35.0001H35C35 36.4211 33.741 37.5721 32 37.8981Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35C58.2091 35 60 33.2091 60 31C60 28.7909 58.2091 27 56 27C53.7909 27 52 28.7909 52 31C52 33.2091 53.7909 35 56 35Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54 36.6504V60.0004H58V36.6504C57.373 36.8724 56.702 37.0004 56 37.0004C55.298 37.0004 54.627 36.8724 54 36.6504Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4 36.6504V60.0004H8V36.6504C7.373 36.8724 6.702 37.0004 6 37.0004C5.298 37.0004 4.627 36.8724 4 36.6504Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6 35C8.20914 35 10 33.2091 10 31C10 28.7909 8.20914 27 6 27C3.79086 27 2 28.7909 2 31C2 33.2091 3.79086 35 6 35Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7207 56L20.3867 60H41.6127L40.2787 56H21.7207Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.028 23.9924L34.58 23.0004H32.999C32.59 23.0004 32.223 22.7514 32.07 22.3714L30.999 19.6924L29.928 22.3714C29.775 22.7514 29.408 23.0004 28.999 23.0004H27.418L28.97 23.9924C29.339 24.2294 29.512 24.6794 29.395 25.1024L28.81 27.2094L30.363 25.9294C30.549 25.7774 30.774 25.7004 31 25.7004C31.226 25.7004 31.451 25.7764 31.637 25.9294L33.19 27.2094L32.605 25.1024C32.486 24.6794 32.659 24.2294 33.028 23.9924Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.1094H9V19.1094H11V17.1094Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.1094H11V21.1094H13V19.1094Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.1094H9V23.1094H11V21.1094Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.1094H7V21.1094H9V19.1094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepImg1);
export default __webpack_public_path__ + "static/media/stepImg1.16d19f8c8b53c484c3b61a8fab98db8c.svg";
export { ForwardRef as ReactComponent };